"use client";
import { useProps } from "../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../core/factory/factory.mjs";
import { ModalBaseBody } from "../ModalBase/ModalBaseBody.mjs";
import { useDrawerContext } from "./Drawer.context.mjs";
import Drawer_module_default from "./Drawer.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Drawer/DrawerBody.tsx
const DrawerBody = factory((_props) => {
	const { classNames, className, style, styles, vars, ...others } = useProps("DrawerBody", null, _props);
	return /* @__PURE__ */ jsx(ModalBaseBody, {
		...useDrawerContext().getStyles("body", {
			classNames,
			style,
			styles,
			className
		}),
		...others
	});
});
DrawerBody.classes = Drawer_module_default;
DrawerBody.displayName = "@mantine/core/DrawerBody";
//#endregion
export { DrawerBody };

//# sourceMappingURL=DrawerBody.mjs.map